import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRepeat } from '@fortawesome/free-solid-svg-icons';

import { getContent } from '../../../util/responseUtil';
import { ROUTER_CONSTANT } from '../../../constants/routerConstant';
import API_SETTINGS from '../../../api/apiSettings';
import Dropdown from '../../../components/Common/Dropdown';
import ActionType from '../../../redux/reducer/globalActionType';
import Alert from '../../../components/Alert/Alert';
import FilterSettingsQueue from '../../../components/Filter/FilterSettingsQueue';
import IconQueue from '../../../assets/icons/IconQueue';
import TableNexcare from '../../../components/Table/TableNexcare';
import { CheckPermissionComponent } from '../../../util/permission';
import { SETTING_QUEUE_VIEW } from '../../../constants/menuPermissionConstant';

class QueueEscalated extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0,
            },
            columns: [
                {
                    title: "Nama CS",
                    dataIndex: "name",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => `${data}`,
                },
                {
                    title: "Level CS",
                    dataIndex: "level",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => `${data}`,
                },
                {
                    title: "Tiket Terakhir",
                    dataIndex: "last_ticket_no",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => `${data}`,
                },
                {
                    title: "Jumlah Antrian",
                    dataIndex: "queue_amount",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => `${data}`,
                },
            ],
            queueEscalated: {
                orderBy: [],
                searchBy: [],
                order: 'user_cs.id',
                filter: '',
                data: [],
                reset: false
            },
            showLoadMore: true,
            showErrorAlertResponse: false,
            errorMessage: ''
        }
    }

    getInitiateQueueEscalated = () => {
        API_SETTINGS.getInitiateQueueEscalated(this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        queueEscalated: {
                            ...this.state.queueEscalated,
                            orderBy: getContent(res).valid_order_by,
                            searchBy: getContent(res).valid_search_by
                        },
                        pagination: { ...this.state.pagination, total: getContent(res).count_data }
                    })
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getQueueEscalated = (page, limit, order, filter) => {
        API_SETTINGS.getQueueEscalated(page, limit, order, filter, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        queueEscalated: {
                            ...this.state.queueEscalated,
                            data: getContent(res)
                        }
                    })
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    handleChangeOrderBy = order => {
        this.setState({
            queueEscalated: {
                ...this.state.queueEscalated,
                order: order.value,
                page: 1,
                reset: false
            }
        })
    }

    handleFilter = filter => {
        let filterEscalated = `&list_cs_id=${filter.customerService}&start_date=${filter.startDate}&end_date=${filter.endDate}`

        this.setState({
            queueEscalated: {
                ...this.state.queueEscalated,
                filter: filterEscalated
            }
        })
    }

    handleReset = () => {
        this.setState({
            queueEscalated: {
                ...this.state.queueEscalated,
                filter: ''
            }
        })
    }

    handleResetSearch = async () => {
        await this.setState({
            queueEscalated: {
                ...this.state.queueEscalated,
                filter: '',
                order: 'user_cs.id',
                reset: true
            }
        })
        this.getQueueEscalated(this.state.pagination.current, this.state.pagination.pageSize, this.state.queueEscalated.order, this.state.queueEscalated.filter);
    }

    handleSearch = async () => {
        await this.setState({
            queueEscalated: {
                ...this.state.queueEscalated,
                page: 1
            }
        })
        this.getQueueEscalated(this.state.pagination.current, this.state.pagination.pageSize, this.state.queueEscalated.order, this.state.queueEscalated.filter);
    }

    handleSelectedPage = currentPage => {
        this.setState(
            {
                pagination: {
                    ...this.state.pagination,
                    current: currentPage,
                },
            },
            () => {
                this.getInitiateQueueEscalated();
                this.getQueueEscalated(this.state.pagination.current, this.state.pagination.pageSize, this.state.queueEscalated.order, this.state.queueEscalated.filter);
            }
        );
    };

    handleSelectedPageSize = currentPageSize => {
        this.setState(
            {
                pagination: {
                    ...this.state.pagination,
                    pageSize: currentPageSize,
                    current: 1,
                },
            },
            () => {
                this.getInitiateQueueEscalated();
                this.getQueueEscalated(this.state.pagination.current, this.state.pagination.pageSize, this.state.queueEscalated.order, this.state.queueEscalated.filter);
            }
        );
    }

    componentDidMount() {
        this._isMounted = true;

        this.getInitiateQueueEscalated();
        this.getQueueEscalated(this.state.pagination.current, this.state.pagination.pageSize, this.state.queueEscalated.order, this.state.queueEscalated.filter);
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <CheckPermissionComponent permissionConstant={[SETTING_QUEUE_VIEW]} userPermission={this.props.userDetail.permissions}>
                <div className="flex items-center mb-5">
                    <NavLink
                        to={ROUTER_CONSTANT.SETTINGS_QUEUE_ASSIGNED}
                        className="rounded-full bg-white text-darkblue font-bold shadow-lg border-2 border-white px-5 py-1 mr-5 flex items-center"
                        activeClassName="bg-blue-200 border-2 border-white"
                        id="btnqueueassigned"
                    >
                        <IconQueue />
                        <span className="ml-2">Antrian Tiket Penugasan</span>
                    </NavLink>
                    <NavLink
                        to={ROUTER_CONSTANT.SETTINGS_QUEUE_ESCALATED}
                        className="rounded-full bg-white text-darkblue font-bold shadow-lg border-2 border-white px-5 py-1 mr-5 flex items-center"
                        activeClassName="bg-blue-200 border-2 border-white"
                        id="btnqueuescalated"
                    >
                        <IconQueue />
                        <span className="ml-2">Antrian Tiket Eskalasi</span>
                    </NavLink>
                </div>
                <div className="flex text-gray-600 relative calculate-layout-button">
                    <div className="w-full bg-white rounded-lg p-16 relative">
                        {/* Filter Escalated Queue */}
                        <div className="header flex justify-between mb-8">
                            <div className="w-full pr-3">
                                <label>Filter</label>
                                <FilterSettingsQueue handleFilter={this.handleFilter} resetFilter={this.handleReset} />
                            </div>
                            <div className="w-full pr-3">
                                <label>Sortir Data</label>
                                <Dropdown
                                    id="ddlorderby"
                                    placeholder="Pilih Sortir Data"
                                    handleChange={this.handleChangeOrderBy}
                                    data={this.state.queueEscalated.orderBy.map(data => ({ value: data, label: data }))}
                                    reset={this.state.queueEscalated.reset}
                                />
                            </div>
                            <div className="mt-5">
                                <div className="flex">
                                    <div className="bg-lightblue h-10 w-10 p-5 rounded text-white flex justify-center items-center mt-1 cursor-pointer" id="btnreload" onClick={() => window.location.reload()}>
                                        <FontAwesomeIcon icon={faRepeat} />
                                    </div>
                                    <button type="button" id="btnreset" className="h-10 w-24 border border-darkblue text-darkblue rounded mt-1 ml-1" onClick={() => this.handleResetSearch()}>Atur Ulang</button>
                                    <button type="button" id="btnsearch" className="h-10 bg-darkblue text-white rounded px-5 mt-1 ml-1" onClick={() => this.handleSearch()}>Cari</button>
                                </div>
                            </div>
                        </div>
                        {/* Table Escalated Queue */}
                        <TableNexcare
                            column={this.state.columns}
                            dataTable={this.state.queueEscalated.data}
                            pagination={this.state.pagination}
                            onPage={this.handleSelectedPage}
                            onPageSize={this.handleSelectedPageSize}
                            halfBodyHeight
                        />
                    </div>
                    <Alert show={this.state.showErrorAlertResponse} icon="warning" title={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
                </div>
            </CheckPermissionComponent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(QueueEscalated);